const getDepartmentName = (department) =>
  department.catalogDisplayName ||
  department.displayName ||
  department.name ||
  'Untitled Department'

const sortFunction = (departmentA, departmentB) => {
  const departmentAName = getDepartmentName(departmentA).toLowerCase()
  const departmentBName = getDepartmentName(departmentB).toLowerCase()

  if (departmentAName < departmentBName) {
    return -1
  }
  if (departmentAName > departmentBName) {
    return 1
  }

  // names must be equal
  return 0
}

export const groupDepartmentAlphabetically = (allDepartments) => {
  const departments = [...allDepartments].sort(sortFunction).reduce((r, e) => {
    // get first letter of disaplyed name of current department
    const group = e.catalogDisplayName?.[0] || e.displayName?.[0] || e.name?.[0]
    // if there is no property in accumulator with this letter create it
    if (!r[group]) r[group] = { group, children: [e] }
    // if there is push current element to children array for that letter
    else r[group].children.push(e)
    // return accumulator
    return r
  }, {})
  return Object.values(departments)
}
